/**
 * Daily limit types and configurations for account objectives
 */

export enum DailyLimitType {
  DailyLoss = 'daily-loss',
  DailyPause = 'daily-pause',
}

export interface DailyLimitConfig {
  type: DailyLimitType;
  percentage?: number;
  fixedAmount?: number;
  isPercentageBased: boolean;
}

export interface DailyLimitCalculation {
  currentValue: number;
  limitValue: number;
  remainingAmount: number;
  isOverLimit: boolean;
}
